<script>
  import { onMount } from "svelte";
  import gsap from "gsap";
  import { ScrollTrigger } from "gsap/ScrollTrigger";
  const ui = "/assets_default/images/business/top/ui.webp"
  const ui_movie = "/assets_default/images/business/top/ui-movie.mp4"
  let videoElement;

  onMount(() => {
    videoElement.pause();

    gsap.registerPlugin(ScrollTrigger);

    gsap.to(".ui-section", {
      y: 0,
      opacity: 1,
      duration: 1.5,
      ease: "power4.out",
      scrollTrigger: {
        trigger: ".ui-section",
        start: "top 80%",
      }
    });

    setTimeout(() => {
      ScrollTrigger.create({
        trigger: ".ui-area-movie",
        start: "top center",
        onEnter: () => videoElement.play(),
      });
    });
  });
</script>

<section class="ui-section">
  <h2 class="owd-heading:07 align:center spacing:bottom:40">わかりやすく<br class="show:sp">実用的なサービスで<br>ビジネスをサポート</h2>
  <p class="owd-text:01 align:center">事業に本当に必要な機能だけを使いやすく。
    <br>最短翌営業日での口座開設、そして安心安全なパスキー認証。
    <br class="show:pc">時間もコストも有効活用し、あなたの事業を力強くサポートします。
  </p>
  <div class="ui-area">
    <img src="{ui}" width="992" height="193" alt="イメージ画像">
    <div class="ui-area-movie">
      <video src="{ui_movie}" preload="metadata" muted playsinline loop bind:this={videoElement} on:ended={() => videoElement.play()}></video>
    </div>
  </div>
</section>

<style lang="scss">
  .ui-section{
    opacity: 0;
    transform: translateY(100px);
    @include g.mobile () {
      h2{
        @include g.owd-typography($fz: 'heading-2-large', $line-height-px: 48, $letter-spacing-tracking: 25, $font-weight: 600);
        padding: 3.5px 0;
      }
    }
    .ui-area{
      width: 95%;
      max-width: 988px;
      margin: 48px auto 0;
      filter: drop-shadow(10px 10px 15px rgba(0, 0, 0, 0.2));
      &-movie{
        width: 100%;
        aspect-ratio: 988/568;
        // background-color: red;
        border-radius: 0 0 15px 15px;
        overflow: hidden;
        video{
          width: 100%;
          height: auto;
        }
      }
      @include g.mobile () {
        width: 100%;
        margin: 24px auto 0;
        &-movie{
          border-radius: 0 0 5px 5px;
        }
      }
    }
    @include g.mobile () {
      width: calc(100% - (24px*2));
      margin-left: auto;
      margin-right: auto;
      padding-bottom: 35px;
    }
  }
</style>
